import { css } from '@emotion/react'

import type { StepperVariant } from './stepper'

export const container = css`
  display: grid;
  position: relative;
  width: 100%;
`

export const variant: Record<StepperVariant, ReturnType<typeof css>> = {
  vertical: css`
    grid-auto-flow: row;
  `,
  horizontal: css`
    grid-auto-flow: column;
  `,
}
